module.exports = __webpack_public_path__ + "img/icon_payway58.c145dd9d.png";